/**
 * Convert a note title to a URL-safe slug
 */
export function titleToSlug(title: string): string {
	return (
		title
			.toLowerCase()
			.trim()
			// Replace spaces and special characters with hyphens
			.replace(/[^\w\s-]/g, '')
			.replace(/[\s_-]+/g, '-')
			// Remove leading/trailing hyphens
			.replace(/^-+|-+$/g, '')
	)
}

/**
 * Convert a slug back to a searchable title pattern
 * This creates a LIKE pattern for database searches
 */
export function slugToTitlePattern(slug: string): string {
	// Convert hyphens back to spaces and create a flexible search pattern
	return slug.replace(/-/g, ' ')
}

/**
 * Check if a title matches a slug
 */
export function titleMatchesSlug(title: string, slug: string): boolean {
	return titleToSlug(title) === slug
}
